import { Component, OnInit, Input, HostListener, ViewChild, ElementRef } from '@angular/core';
import { DetailService } from '../services/detail.service';
import { MdePopoverTrigger } from '@material-extended/mde';
import { WorkspaceService } from '../services/workspace.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {

  @Input() helpId: string;
  @Input() set placement(event){
    this.position = event;
  }
  loadingMessage: string = "Loading the element help display text... Please wait for a moment";
  helpDisplay : string;
  position: string = "top";
  
  @ViewChild(MdePopoverTrigger) trigger: MdePopoverTrigger;

  constructor(private detailService:DetailService, private workspaceService: WorkspaceService) { 
    // this.workspaceService.documentClickChanged$.subscribe(result => {
    //   this.offClickHandler(result);
    // })
  }

  ngOnInit() {
    this.helpDisplay = this.loadingMessage;
    this.getHelpById()
  }

  getHelpById() {
    if (this.helpDisplay == "Loading the element help display text... Please wait for a moment"){
      document.querySelectorAll("body").item(0).style.position = "relative";
      this.detailService.getHelp(this.helpId).subscribe(result => {
        this.helpDisplay = result;
      });
    }
  }

  // opened(event){
  //   console.log(event)
  //   document.querySelectorAll(".cdk-overlay-backdrop").item(0).classList.add('hide');
  // }

  // closed(){
  //   document.querySelectorAll(".cdk-overlay-backdrop").item(0).classList.remove('hide');
  // }

  // offClickHandler(result:any) {
  //   console.log(this.trigger); 
  //   console.log(result);

  //   if (result.target.className != "help-icon-img" && result.target.className != "help-icon" ){
  //     if (this.trigger){
  //       if (this.trigger.popoverOpen){
  //         this.trigger.closePopover();
  //       }
  //     } 
  //   }

  // }
}
